import { ValueLabel } from "@features/ax/shared/ValueLabel";

const MessageActivityDetailsRecipientInfo = ({ data }: { data: any }) => {
  const valueFields = [
    {
      label: "Name",
      value: data?.data?.recipientInfo?.name,
    },
    {
      label: "Recipient Type",
      value: data?.data?.recipientInfo?.audienceType,
    },
    {
      label: "Account Number",
      value: data?.data?.recipientInfo?.accountNumber,
    },
    {
      label: "Email",
      value: data?.data?.recipientInfo?.recipientEmail,
    },
    {
      label: "Phone",
      value: data?.data?.recipientInfo?.recipientPhone,
    },
    {
      label: "Role",
      value: data?.data?.recipientInfo?.role,
    },
  ];
  return (
    <div className="space-y-6 pl-2 pt-1">
      <h3 className="text-lg font-bold">Recipient Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {valueFields.map((field, index) => (
          <ValueLabel label={field.label} value={field.value} />
        ))}
      </div>
    </div>
  );
};

export default MessageActivityDetailsRecipientInfo;
